import React from 'react';
import { FormSelect, FormMultiSelect } from '../formControls';
import { BROKER_ROLE } from 'src/organizations/components/forms/constants';
import { useGetOrganizationsLookup } from 'src/fetch/organizations';
import { emptyArray } from 'src/shared/helpers/utils';

const BrokerDropdown = (props) => {
  const { data: brokers = emptyArray } = useGetOrganizationsLookup({ roles: [BROKER_ROLE] });

  const value = props.value && (typeof props.value === 'object' ? props.value : brokers.find((x) => x.id === props.value));

  const SelectComponent = props.multiSelect ? FormMultiSelect : FormSelect;

  return <SelectComponent data={brokers} textField='name' dataItemKey='id' {...props} value={value} />;
};

export default BrokerDropdown;
